/**
 * Every route of the app that has a `:param` segment. This light module is the one place that defines them (a test fails
 * if another file does), so the error reporting can replace the value of each parameter (a recovery token, an invitation,
 * a user or ticket id) before an event leaves the browser. Nested routes are relative to the page that renders them.
 */
export const PASSWORD_RECOVERY_TOKEN_PATH = '/password-recovery/:token';
export const JOIN_PATH = '/join/:userId';
export const USER_PROFILE_PATH = '/profile/:externalUserId';
export const BLOG_POST_PATH = '/post/:id';
export const SUPPORT_TICKET_PATH = '/ticket/:cardId';

/** The full path of every route with a parameter. */
export const PARAMETRISED_ROUTES = [
  PASSWORD_RECOVERY_TOKEN_PATH,
  JOIN_PATH,
  `/users${USER_PROFILE_PATH}`,
  `/blog${BLOG_POST_PATH}`,
  `/support${SUPPORT_TICKET_PATH}`,
];
